import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'

import { useDispatch } from 'react-redux'
import { getBusinessVisits } from 'src/store/actions/api'

import Loading from 'src/components/Loading'
import TechnicalLaborsForm from './TechnicalLaborsForm'

import './TechnicalLabors.sass'

const TechnicalLabors = () => {
  const dispatch = useDispatch()
  const params = useParams()
  const locationId = parseInt(params.locationId)
  const visitId = parseInt(params.visitId)

  const [hasErrorLoading, setHasErrorLoading] = useState(null)
  const [currentVisit, setCurrentVisit] = useState(null)
  const [estanco, setEstanco] = useState(null)
  const isLoading = hasErrorLoading === null

  useEffect(() => {
    if (locationId && visitId) {
      dispatch(getBusinessVisits(locationId))
        .then((res) => {
          const visit = res.visitas && res.visitas.find((v) => v.id === visitId)
          setCurrentVisit(visit)
          setEstanco(res.estanco)
          setHasErrorLoading(!visit)
        })
        .catch(() => {
          setHasErrorLoading(true)
        })
    }
  }, [dispatch, locationId, visitId])

  const errorMsg = (
    <div className="technical-labors-error-msg">
      <FormattedMessage id="technical-labors.api-error" />
    </div>
  )

  return (
    <div id="technical-labors" className="page">
      <header id="location-header">
        <Link className="cancel link" to={'/location/' + locationId + '/history'}>
          <span className="icon icon-cross" />
        </Link>
        <h1>
          <FormattedMessage id="technical-labors.title" />
        </h1>
      </header>
      <div id="technical-labors-photo">
        <div className="icon" />
        <div className="logo" />
      </div>
      {isLoading ? (
        <Loading />
      ) : hasErrorLoading ? (
        errorMsg
      ) : (
        <TechnicalLaborsForm
          visitId={visitId}
          locationId={locationId}
          initialData={currentVisit ? currentVisit.labores_tecnicas : {}}
          distanciaValtrack={estanco ? estanco.distanciaValtrack : null}
        />
      )}
    </div>
  )
}

export default TechnicalLabors
